import styled from "styled-components";

const FieldLabel = styled.label`
  font-size: 14px;
  margin-bottom: 8px;
`;

export default FieldLabel;
